import React from "react";

const HomeHeader = ({ userDetails }) => {
  const firstName = userDetails?.name?.split(" ")?.[0];

  return (
    <div className="home-header">
      <div>
        <h1 className="home-title">
          {firstName ? `Welcome, ${firstName}` : "Project Dashboard"}
        </h1>

        <p className="home-subtitle">
          Select a project to open its dashboard. You can also choose{" "}
          <strong>All Projects</strong> for a portfolio-level view.
        </p>
      </div>
    </div>
  );
};

export default HomeHeader;
